import { api } from "@/lib/api";

const CHUNK_SIZE = 10 * 1024 * 1024; // 10MB chunks stay well under proxy limits on slow connections

// Resumable chunked upload: per-chunk retries, then up to 2 resume rounds that ask the
// server which chunks it already holds and continue from the first gap.
// onProgress receives display text like "photo.jpg 45%" / "photo.jpg — reconnecting…".
export const uploadChunkedFile = async (file, label, onProgress = () => {}) => {
  const { data: start } = await api.post("/admin/uploads/start", {
    filename: file.name, content_type: file.type || "application/octet-stream",
  });
  const uploadId = start.upload_id;
  const chunks = Math.max(1, Math.ceil(file.size / CHUNK_SIZE));
  let done = new Set();
  const report = () => onProgress(`${label} ${Math.round((done.size / chunks) * 100)}%`);

  for (let round = 0; round < 3; round++) {
    try {
      if (round > 0) {
        const { data: st } = await api.get(`/admin/uploads/${uploadId}`);
        done = new Set(st.received_chunks);
        onProgress(`${label} — reconnecting, resuming at ${Math.round((done.size / chunks) * 100)}%…`);
        await new Promise((r) => setTimeout(r, 1500));
      }
      for (let i = 0; i < chunks; i++) {
        if (done.has(i)) continue;
        const blob = file.slice(i * CHUNK_SIZE, (i + 1) * CHUNK_SIZE);
        let sent = false;
        let lastErr = null;
        for (let attempt = 0; attempt < 3 && !sent; attempt++) {
          try {
            await api.post(`/admin/uploads/${uploadId}/chunk?index=${i}`, blob, {
              headers: { "Content-Type": "application/octet-stream" },
            });
            sent = true;
          } catch (err) {
            lastErr = err;
            await new Promise((r) => setTimeout(r, 1000 * (attempt + 1)));
          }
        }
        if (!sent) throw lastErr;
        done.add(i);
        report();
      }
      const { data: fin } = await api.post(`/admin/uploads/${uploadId}/complete`, { chunks });
      return fin.path;
    } catch (err) {
      if (round === 2) throw err;
    }
  }
  throw new Error("Upload failed");
};
